module.exports = __webpack_public_path__ + "media/images/i3LEARNHUB-Packshot-ppds-c79efa8bd7ad4108d51a2f92b8ba32cb.png";